/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useState, useRef } from 'react'
import { Modal, Button, Form} from 'semantic-ui-react'
import {API_URL} from '../../../constants';
import {useTranslation} from 'react-i18next';
import {uploadFile} from '../../../services/Item/Item.service';
import { ultyToast } from '../../Shared/UltyToast/UltyToast'

const FileTemplateUrls = {
    'AVAILABILITY' : `${API_URL}/templates/product_availability.xlsx`,
}

const ProductAvailabilitiesImport = ({ reload }) => {
    const [t] = useTranslation();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const fileRef = useRef()
    const [file, setFile] = useState(null)

    const handleSubmit = async () => {
        setLoading(true);

        try {
            const bodyFormData = new FormData();
            bodyFormData.append('datafile', file[0]);
            bodyFormData.append('datacontent', 'AVAILABILITY');
            const {scheduled=false} = await uploadFile(bodyFormData);
            const displayedMessage = scheduled
                    ? t('product_list.import.scheduled')
                    : t('product_list.import.processed');

            ultyToast({ type: 'success', title: displayedMessage })

            if (reload) {
                await reload();
            }
            setOpen(false);
        } catch (e) {
            if (e.message === 'import_already_requested') {
                ultyToast({ type: 'error', title: t('product_list.import.import_already_requested') })
            }
            else {
                ultyToast({ type: 'error', title: t('product_list.import.error') })
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          closeIcon
          trigger={
            <Button
              onClick={() => setOpen(true)}
              basic
              icon='download'
              color="teal"
              content={t('product_list.import.button')}
            />
        }>
                <Modal.Header>{t('product_list.import.header')}</Modal.Header>
                <Modal.Content>
                    <Form onSubmit={handleSubmit}>
                        <Form.Select
                          fluid
                          label={t('product_list.import.fileType')}
                          options={[ { text: t('product_list.import.stock_availability'), value: 'AVAILABILITY', key: 'AVAILABILITY' } ]}
                          defaultValue='AVAILABILITY'
                          value={'AVAILABILITY'}
                        />
                        <p>
                            <a href={FileTemplateUrls.AVAILABILITY}>{t('import.downloadImportTemplateXLSX')}</a>
                        </p>

                        <Form.Field css={css`margin-top: 20px;`}>
                            <label>{t('product_list.import.file')}</label>
                        </Form.Field>
                        <Form.Field>
                            <input type="file" ref={fileRef} onChange={() => {
                                setFile(fileRef.current.files)
                            }} />
                        </Form.Field>
                        <div style={{ textAlign: 'right' }}>
                            <Button loading={loading} disabled={loading || !file} type="submit" color="teal">{t('product_list.import.import')}</Button>
                        </div>
                    </Form>
                </Modal.Content>
            </Modal>
    )
}

export { ProductAvailabilitiesImport }
